
import { apiSlice } from './apiSlice';
const USERS_URL = `${process.env.REACT_APP_BACKEND_URI}/api/v1`;
// const USERS_URL = process.env.REACT_APP_BACKEND_URI;


export const angelOneApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    //    getAngelProfile : builder.query({
    //   query: (data) => ({
    //     url: `${USERS_URL}/getprofile`,
    //     method: 'GET',
    //     credentials: "include",
    //   }),
    // }),
    logoutAngelone: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/angel-one/angelone-logout`,
        method: 'POST',
        credentials: "include",

      }),

    }),
    getAngelOrders: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/angel-one/angel-order/${userId}`,
        method: 'GET',
        credentials: "include",
      }),
    }),
    getAngelonePosition: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/angelOne/positions/${userId}`,
        CreateAutoPaySubscription: 'GET',
        credentials: "include",
      }),
    }),
    getAngelOrderPnl: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/angelOne/angelorder-pnl/${userId}`,
        method: 'GET',
        credentials: "include",
      }),
    }),
getAngeloneHolding: builder.query({
  query: ({ userId, broker }) => ({
    url: `${USERS_URL}/angelOne/holdings/${userId}`,
    method: 'GET',
    credentials: "include",
    params: { broker },
  }),
}),

    // getAllExecutedTrades: builder.query({
    //   query: (userId) => ({
    //     url: `${USERS_URL}/angel-one/trades`,
    //     method: 'GET',
    //     credentials: "include",
    //   }),
    // }),
    connectGroww: builder.mutation({
      query: (userId) => ({
        url: `${USERS_URL}/groww/callback`,

        method: 'POST',
        body: { userId },
      }),
    }),
  }),
});

// Export hooks for usage in components
export const {
  useLogoutAngeloneMutation, useGetAngelOrdersQuery, useGetAngeloneHoldingQuery, useGetAngelonePositionQuery, useGetAngelOrderPnlQuery
  , useConnectGrowwMutation
} = angelOneApiSlice;




